import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CustomerProfileCard} from '../../api/entity/customer-profile-cards';
import {CustomerCardsService} from '../../api/service/customer-cards.service';
import {CurrenciesService} from '../../../../../../../common/api/dictionaries';
import {DictionaryObject} from '../../../../../../../common/api';
import {CardFilterModel} from './card/card-filter-model.i';
import {CardStatesService} from '../../api/service/card-states-service';
import {CustomerService} from '../../../../../shared/api/service';
import {Currency} from '../../../../../shared/api/entity';
import { CustomerProfileService } from '../../api';
import {isNullOrUndefined} from 'util';
import {mapValues} from 'lodash';

const DEFAULT_OPTION = 'undefined';
const MIN_SYMBOLS = 3;
const MAX_SYMBOLS = 50;

@Component({
    selector: 'tfl-profile-detail-cards',
    template: require('./profile.cards.template.html'),
    providers: [CustomerCardsService, CurrenciesService, CardStatesService]
})
export class ProfileCardsComponent implements OnInit {

    cards: CustomerProfileCard[];
    isBlocked: boolean = false;
    private _profileId: number;
    private shouldDisableSearchButton: boolean = true;
    states: DictionaryObject[];
    currencies: Currency [];
    filterModel: CardFilterModel;

    constructor(private _customerCardService: CustomerCardsService,
                private activatedRoute: ActivatedRoute,
                private customerService: CustomerService,
                private _currenciesService: CurrenciesService,
                private _customerProfileService: CustomerProfileService,
                private _cardStatesService: CardStatesService) {
        this.resetFilterModel();
    }

    ngOnInit(): void {
        this.activatedRoute.parent.params.subscribe(params => this._profileId = +params['id']);
        if (this._profileId) {
            this.fetchCustomerCards();
            this.fetchCardStates();
            this.fetchCurrencies();
        }
    }

    fetchCustomerCards() {
        this._customerCardService.getCustomerCards(this._profileId, this.filterModel)
            .subscribe(response => this.cards = response);
    }

    updateCards() {
        this.fetchCustomerCards();
    }

    isFilterModelNotViableForSearch(): boolean {
        this.preventOfDefaultSelectTagOptionOrValues();

        let valid = true;
        let compose_checker = true;
        let isCardholderValid = false;
        let isCardNumberValid = false;
        if (!isNullOrUndefined(this.filterModel.cardHolderName)) {
            let cardHolderNameSize = this.filterModel.cardHolderName.length;
            isCardholderValid = (cardHolderNameSize <= MAX_SYMBOLS && cardHolderNameSize >= MIN_SYMBOLS);
        }
        if (!isNullOrUndefined(this.filterModel.cardNumber)) {
            let cardNumberNameSize = this.filterModel.cardNumber.length;
            isCardNumberValid = (cardNumberNameSize <= MAX_SYMBOLS && cardNumberNameSize >= MIN_SYMBOLS);
        }
        if (!isNullOrUndefined(this.filterModel.cardHolderName)
            && !isNullOrUndefined(this.filterModel.cardNumber)) {
            valid = isCardholderValid && isCardNumberValid;
        }

        valid = valid && (isCardholderValid || isCardNumberValid);

        if ((!isNullOrUndefined(this.filterModel.cardHolderName)
            || !isNullOrUndefined(this.filterModel.cardNumber))
            && !this.shouldDisableSearchButton) {
            compose_checker = valid;
        }

        return !((!this.shouldDisableSearchButton || valid) && compose_checker);
    }

    get filtersCallUrl() {
        return `/api/backoffice/cards/all-for-profile/${this._profileId}/`;
    }

    onResetHandler() {
        this.resetFilterModel();
        this.fetchCustomerCards();
    }

    handleSearchResponse(response) {
        this.shouldDisableSearchButton = false;
        this.cards = response.cards;
    }

    onChangeSelect(value) {
        if (value === DEFAULT_OPTION) {
            this.shouldDisableSearchButton = true;
        } else {
            this.shouldDisableSearchButton = false;
        }
    }

    private fetchCardStates() {
        this._cardStatesService.getRegisteredClientCardStates()
            .subscribe(states => this.states = states)
    }

    private fetchCurrencies() {
        this._currenciesService.getCurrencies()
            .subscribe(currencies => (this.currencies = currencies))
    }

    private resetFilterModel() {
        this.filterModel = Object.assign(this.filterModel || {}, {
            cardHolderName: undefined,
            cardNumber: undefined,
            cardState: undefined,
            cardCurrency: undefined,

        });
    }

    private preventOfDefaultSelectTagOptionOrValues() {
        this.filterModel = Object.assign(this.filterModel,
            mapValues(this.filterModel, (v) => (String(v) === DEFAULT_OPTION || String(v) === '') ? undefined : v));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/cards/profile.cards.component.ts